import { render, staticRenderFns } from "./EdenFormSection.vue?vue&type=template&id=52a894be&scoped=true"
import script from "./EdenFormSection.vue?vue&type=script&lang=js"
export * from "./EdenFormSection.vue?vue&type=script&lang=js"
import style0 from "./EdenFormSection.vue?vue&type=style&index=0&id=52a894be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a894be",
  null
  
)

export default component.exports